module.exports = __webpack_public_path__ + "static/media/ic_cross-circle-red.eb86acd0.svg";